import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import FleetMap from "../components/FleetMap";
import { Warning, Phone, ArrowsOut, CheckCircle, X } from "@phosphor-icons/react";

export default function Emergency() {
  const [ems, setEms] = useState([]);
  const [sel, setSel] = useState(null);

  const load = () => api.get("/emergencies").then((r) => {
    setEms(r.data.emergencies);
    setSel((s) => s ? r.data.emergencies.find((e) => e.id === s.id) || r.data.emergencies[0] : r.data.emergencies[0]);
  });

  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, []);

  const act = async (action) => {
    if (!sel) return;
    await api.patch(`/emergencies/${sel.id}`, { action });
    toast.success(`Emergency ${action}d`);
    load();
  };

  const active = ems.filter((e) => e.status === "ACTIVE");

  return (
    <div className="h-full flex flex-col">
      <div className="bg-red-950/40 border-b border-destructive px-5 py-3 flex items-center gap-3">
        <Warning size={22} weight="fill" className="text-destructive pulse-danger rounded-full" />
        <h1 className="font-display font-black text-2xl tracking-tight text-destructive">ACTIVE EMERGENCIES</h1>
        <span className="ml-auto font-display font-black text-2xl text-destructive">{active.length}</span>
      </div>

      <div className="flex-1 flex min-h-0">
        <div className="w-80 shrink-0 border-r border-border overflow-y-auto bg-card">
          {ems.length === 0 && <div className="p-6 text-sm text-muted-foreground">No emergencies.</div>}
          {ems.map((e) => (
            <button key={e.id} data-testid={`emergency-item-${e.vehicle_number}`}
              onClick={() => setSel(e)}
              className={`w-full text-left p-4 border-b border-border ${sel?.id === e.id ? "bg-destructive/10" : "hover:bg-white/5"} ${e.status === "ACTIVE" ? "border-l-2 border-l-destructive" : ""}`}>
              <div className="flex justify-between items-center">
                <span className="font-display font-bold text-lg">{e.vehicle_number}</span>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-sm ${e.status === "ACTIVE" ? "bg-destructive text-white pulse-danger" : "bg-secondary text-muted-foreground"}`}>
                  {e.status}
                </span>
              </div>
              <div className="text-xs text-muted-foreground mt-1">PANIC BUTTON · {e.driver_name}</div>
              <div className="text-xs text-muted-foreground">{new Date(e.created_at).toLocaleTimeString()}</div>
            </button>
          ))}
        </div>

        {sel ? (
          <div className="flex-1 flex flex-col min-w-0" data-testid="emergency-detail">
            <div className="flex-1 min-h-[260px]">
              <FleetMap vehicles={[{ id: sel.id, vehicle_number: sel.vehicle_number, lat: sel.lat, lng: sel.lng, speed: sel.speed, status: "panic", device_model: "" }]}
                center={[sel.lat, sel.lng]} zoom={13} />
            </div>
            <div className="border-t border-border bg-card p-4 max-h-[45%] overflow-y-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                <div><div className="label-caps">Vehicle</div><div className="font-bold">{sel.vehicle_number}</div></div>
                <div><div className="label-caps">Driver</div><div className="font-bold">{sel.driver_name}</div></div>
                <div><div className="label-caps">Speed</div><div className="font-bold">{sel.speed} km/h</div></div>
                <div><div className="label-caps">Mobile</div><div className="font-bold">{sel.driver_mobile}</div></div>
              </div>
              <div className="label-caps mb-2">Timeline</div>
              <div className="space-y-1.5 mb-4">
                {sel.timeline.map((t, i) => (
                  <div key={i} className="flex items-center gap-2 text-sm">
                    <CheckCircle size={14} weight="fill" color="#34C759" />
                    <span className="text-muted-foreground font-mono text-xs">{new Date(t.time).toLocaleTimeString()}</span>
                    <span>{t.event}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap gap-2">
                <a href={`tel:${sel.driver_mobile}`} className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2 border border-border rounded-sm hover:border-primary">
                  <Phone size={14} weight="fill" /> Call Driver
                </a>
                <button data-testid="emergency-acknowledge" onClick={() => act("acknowledge")} className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2 border border-border rounded-sm hover:border-primary"><CheckCircle size={14} weight="bold" /> Acknowledge</button>
                <button data-testid="emergency-escalate" onClick={() => act("escalate")} className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2 border border-border rounded-sm hover:border-[#FF9500]"><ArrowsOut size={14} weight="bold" /> Escalate</button>
                <button data-testid="emergency-close" onClick={() => act("close")} className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2 bg-destructive text-white rounded-sm ml-auto"><X size={14} weight="bold" /> Close Incident</button>
              </div>
            </div>
          </div>
        ) : <div className="flex-1 flex items-center justify-center text-muted-foreground">Select an emergency</div>}
      </div>
    </div>
  );
}
